import { useTranslation } from 'react-i18next';
import { ProfessionalSituation } from '../../participantEnums';

export const useProfessionalSituations = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: ProfessionalSituation.WORKING,
      label: t('participants.enums.professionalSituation.WORKING'),
    },
    {
      value: ProfessionalSituation.STUDENT,
      label: t('participants.enums.professionalSituation.STUDENT'),
    },
    {
      value: ProfessionalSituation.LOOKING_FOR_JOB,
      label: t('participants.enums.professionalSituation.LOOKING_FOR_JOB'),
    },
    {
      value: ProfessionalSituation.UNEMPLOYED,
      label: t('participants.enums.professionalSituation.UNEMPLOYED'),
    },
    {
      value: ProfessionalSituation.RETIRED,
      label: t('participants.enums.professionalSituation.RETIRED'),
    },
  ];
};
